import { render, staticRenderFns } from "./MarketingMailings.vue?vue&type=template&id=cc279d2a&"
import script from "./MarketingMailings.vue?vue&type=script&lang=js&"
export * from "./MarketingMailings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports